import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function Login() {
  const { login, error } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@shreedhan.app");
  const [password, setPassword] = useState("Demo@1234");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) {
      toast.success("Welcome back to ShreeDhan");
      nav("/home");
    }
  };

  return (
    <div className="min-h-screen bg-paper">
      <div className="mx-auto max-w-md px-6 py-8">
        <Link to="/" data-testid="login-back" className="inline-flex items-center gap-1 text-sm text-brand-slate">
          <ArrowLeft size={16} /> Back
        </Link>

        <div className="mt-8">
          <div className="text-xs font-bold tracking-[0.24em] uppercase text-brand-primary">Namaste, welcome back</div>
          <h1 className="mt-3 font-display text-4xl font-semibold text-brand-charcoal">Sign in to your vault</h1>
          <p className="mt-2 text-brand-slate">Your gold is waiting for you.</p>
        </div>

        <form onSubmit={onSubmit} className="mt-10 space-y-5">
          <div>
            <Label className="text-brand-charcoal text-sm font-semibold">Email</Label>
            <Input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 rounded-xl border-brand-line bg-brand-ivory"
              required
            />
          </div>
          <div>
            <Label className="text-brand-charcoal text-sm font-semibold">Password</Label>
            <Input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-12 rounded-xl border-brand-line bg-brand-ivory"
              required
            />
          </div>

          {error && <div data-testid="login-error" className="text-sm text-brand-primary">{error}</div>}

          <Button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full h-14 rounded-full bg-gold-gradient text-brand-page font-semibold text-base shadow-gold active:scale-[0.98]"
          >
            {loading ? "Signing in…" : "Sign in"}
          </Button>

          <div className="text-center text-sm text-brand-slate">
            New to ShreeDhan?{" "}
            <Link to="/register" data-testid="login-register-link" className="text-brand-primary font-semibold underline underline-offset-4">
              Create account
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
